module.exports = __webpack_public_path__ + "img/16581299_L.a6cf7dd7.png";